/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */
import { getStorage } from "firebase/storage"
import StorageRef from "@/core/js/backend/FIrebaseWrappers/ref/StorageRef";

export default class StorageWrapper {


	storage

	constructor(firebaseWrapper) {
		this.storage = getStorage(firebaseWrapper.firebaseApp)
	}

	ref(path){
		return new StorageRef(this.storage, path)
	}


}
